import {
  FilterMode,
  CreditPurchase_OrderBy,
  CreditPurchase,
  SortOrder,
  CreditPurchase_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const myCreditPurchasesService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.myCreditPurchasesOne({ id });
    return result.myCreditPurchasesOne as CreditPurchase;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: CreditPurchase_OrderBy[] | null = null,
    filter: CreditPurchase_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: CreditPurchase_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.myCreditPurchasesListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.myCreditPurchasesListWithOffset
    ) as CreditPurchase[];
    return { list, orderBy };
  },
};
